import React, { Component } from "react";
import axios from "axios";
import BasicDataComponent from "../common/work-orders/BasicData";
import VehicleComponent from "../common/work-orders/Vehicle";
import TabsComponent from "../common/work-orders/Tabs";
import { Container, Row, Col } from "shards-react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import api from "../common/api";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Slide from "@material-ui/core/Slide";
import AppBar from "@material-ui/core/AppBar";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import BudgetComponent from "../common/work-orders/Budget";
import ValetBudgetComponent from "../common/work-orders/ValetBudget";
import DetailComponent from "../common/work-orders/Detail";
import ProviderComponent from "../common/work-orders/Providers";
import ScheduleComponent from "../common/work-orders/Schedule";
import HistoryComponent from "../common/work-orders/History";
import RelationComponent from "../common/work-orders/Relations";
import VouchersComponent from "../common/work-orders/Vouchers";
import SinisterComponent from "../common/work-orders/Sinister";
import VehicleMovementComponent from "../common/work-orders/VehicleMovement";
import ValetComponent from "../common/work-orders/Valet";
import MobileMessages from "../common/MobileMessages";
import AttachmentsComponent from "../common/work-orders/Attachments";
import UserAlertsComponent from "../common/work-orders/UserAlerts";
import ParkingComponent from "../common/work-orders/Parking";
import TiersComponent from "../common/work-orders/Tiers";
import SinisterLawyerDiligenceComponent from "../common/work-orders/SinisterLawyerDiligence";
import ApprovalComponent from "../common/work-orders/Approvals";
import CommentsComponent from "../common/work-orders/Comments";
import LinearProgress from "@material-ui/core/LinearProgress";
import ConfirmDialog from "../common/ConfirmDialog";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import Input from "@material-ui/core/Input";
import InputMask from "react-input-mask";
import Select from "@material-ui/core/Select";
import Mobile from "../common/work-orders/Mobile";
import WorkOrderChecklist from "../common/work-orders/WorkOrderChecklist";
import Fine from "../common/work-orders/Fine";
import SAP from "../common/work-orders/SAP";
import WorkOrderInvoices from "../common/work-orders/WorkOrderInvoices";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2} style={{ paddingTop: "0px", minHeight: "20px" }}>
          {children}
        </Box>
      )}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`
  };
}

class WorkOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      save: false,
      dialog: {
        open: false,
        message: "",
        title: "",
        errors: { errors: { "work_order.tasks": [] } }
      },
      delete_dialog: {
        open: false,
        message: "",
        title: "",
        errors: { errors: { "work_order.tasks": [] } }
      },
      tab: 0,
      next_state: "",
      can_cancel: false,
      backdrop: false,
      saving: false,
      work_order: {
        id: "",
        state: "",
        reason: "",
        hansa_code: "",
        reason: "",
        work_order_type_id: "",
        internal_code: "",
        internal_code_type: "",
        work_order_origin_id: "",
        work_order_expense_type_id: "",
        is_fleet_owner: "",
        booking: {}
      },
      detail: {
        tasks: {
          tasks: [
            {
              task: {
                name: "",
                group: "",
                subgroup: "",
                work_order_task_action_id: "",
                rebill: "",
                iva_buy_id: "",
                iva_sell_id: "",
                total_discount: ""
              }
            }
          ]
        }
      },
      components: [],
      task_action_types: [{}],
      work_order_expense_types: [{}],
      iva_conditions: { buy: [{}], sell: [{}] },
      work_order_types: [{}],
      work_order_internal_code_types: [{}],
      work_order_origins: [{}],
      work_order_relation_types: [{}],
      work_order_expense_type_id: "",
      schedule: {
        provider: { business_name: "", phone: "", email: "" },
        shift_date: "",
        start_date: "",
        end_date: "",
        custom_address: "",
        custom_address_confirmed: false,
        shift_additional_notes_confirmed: false,
        shift_additional_notes: ""
      },
      sap_dimensions: {},
      relations: [{}],
      vehicle: {
        plate: "",
        owner: "",
        description: "",
        last_km: "",
        last_km_date: "",
        last_km_origin: "",
        is_fleet_owner: "",
        warranty_state: "",
        version: { name: "" },
        client: {
          business_name: ""
        },
        location: { lat: "", lng: "", address: "", state: "", province: "" },
        work_orders: [{ id: 0 }],
        contract: {},
        subcontacts: [
          {
            subcontact: {
              firstname: "",
              lastname: "",
              contact: { phone: "", email: "" }
            }
          }
        ],
        contacts: [{ id: "" }],
        booking_id: {},
        contact_name: "",
        contact_email: "",
        contact_phone: "",
        contact_id: "",
        contact_new: false
      }
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  async componentDidMount() {
    var id = this.props.match.params.id;
    await this.getDropdowns();
    if (id > 0) {
      await this.getWorkOrder(id);
    } else {
      await this.getNewWorkOrder();
    }
  }
  handleRestore = e => {
    this.setState({ backdrop: true });
    var dialog = this.state.dialog;
    var work_order = this.state.work_order;
    e.preventDefault();
    var formData = new FormData();
    formData.set("work_order_id", work_order.id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.work_order().restore(work_order.id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        dialog.title = "Orden de trabajo";
        dialog.open = true;
        dialog.success = 1;
        dialog.message = "Se ha actualizado con éxito!";
        self.setState({ dialog: dialog });
        self.handleCloseBackdrop();
      })
      .catch(function(error) {
        dialog.title = "Orden de trabajo";
        dialog.open = true;
        dialog.success = 0;
        dialog.message = "Ha ocurrido un error!";
        var promise = new Promise(function(resolve, reject) {
          resolve(error.response.data);
          dialog.errors = error.response.data;
        });
        self.setState({ dialog: dialog });
        self.handleCloseBackdrop();
      });

    return;
  };

  handleTransition = (e, transition) => {
    this.setState({ backdrop: true, saving: true });
    if (e) e.preventDefault();
    var i = 0;
    var dialog = this.state.dialog;
    var detail = this.state.detail;
    var work_order = this.state.work_order;
    //  		var detail = this.state.detail
    var vehicle = this.state.vehicle;
    var formData = new FormData();
    formData.set("work_order[id]", work_order.id);
    formData.set("work_order[km]", vehicle.km);
    formData.set(
      "work_order[work_order_type_id]",
      work_order.work_order_type_id
    );
    formData.set("work_order[km_confirmed]", vehicle.km_confirmed ? 1 : 0);
    formData.set("work_order[is_estimated]", vehicle.is_estimated ? 1 : 0);
    formData.set("work_order[plate]", vehicle.plate);
    formData.set(
      "work_order[internal_code_type]",
      work_order.internal_code_type ? work_order.internal_code_type : ""
    );
    formData.set(
      "work_order[internal_code]",
      work_order.internal_code ? work_order.internal_code : ""
    );
    formData.set(
      "work_order[freshdesk_code]",
      work_order.freshdesk_code ? work_order.freshdesk_code : ""
    );
    formData.set(
      "work_order[reason]",
      work_order.reason ? work_order.reason : ""
    );
    formData.set("work_order[is_estimated]", vehicle.is_estimated ? 1 : 0);
    if (this.state.schedule.shift_date !== "") {
      formData.set(
        "work_order[shift_date]",
        this.state.schedule.shift_date.replace("T", " ")
      );
    }
    if (
      this.state.schedule.custom_address_confirmed &&
      this.state.schedule.custom_address !== ""
    ) {
      formData.set(
        "work_order[custom_address]",
        this.state.schedule.custom_address
      );
    }
    if (
      this.state.schedule.shift_additional_notes_confirmed &&
      this.state.schedule.shift_additional_notes !== ""
    ) {
      formData.set(
        "work_order[shift_additional_notes]",
        this.state.schedule.shift_additional_notes
      );
    }

    formData.set("work_order[km]", vehicle.km);

    if (this.state.vehicle.location) {
      formData.set(
        "work_order[location_lat]",
        vehicle.location.lat ? vehicle.location.lat : ""
      );
      formData.set(
        "work_order[location_lng]",
        vehicle.location.lng ? vehicle.location.lng : ""
      );
      formData.set(
        "work_order[location_province]",
        vehicle.location.province ? vehicle.location.province : ""
      );
      formData.set(
        "work_order[location_state]",
        vehicle.location.state ? vehicle.location.state : ""
      );
      formData.set(
        "work_order[location_address]",
        vehicle.location.address ? vehicle.location.address : ""
      );
    }
    if (work_order) {
      formData.set(
        "work_order[work_order_expense_type_id]",
        work_order.work_order_expense_type_id
          ? work_order.work_order_expense_type_id
          : ""
      );
    }
    detail.tasks.tasks.map((val, idx) => {
      if (val.task.id !== "" && val.task.id !== undefined) {
        formData.set("work_order[tasks][" + i + "][task_id]", val.task.id);
        formData.set(
          "work_order[tasks][" + i + "][work_order_task_action_id]",
          val.work_order_task_action_id ? val.work_order_task_action_id : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][comments]",
          val.comments ? val.comments : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][workforce_s_iva_price]",
          val.workforce_s_iva_price ? val.workforce_s_iva_price : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][materials_s_iva_price]",
          val.materials_s_iva_price ? val.materials_s_iva_price : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][total_s_iva_price]",
          val.total_s_iva_price ? val.total_s_iva_price : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][rebill]",
          val.rebill ? val.rebill : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][total_discount]",
          val.total_discount ? val.total_discount : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][iva_buy_id]",
          val.iva_buy_id ? val.iva_buy_id : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][iva_sell_id]",
          val.iva_sell_id ? val.iva_sell_id : ""
        );
        if (val.id !== "" && val.id !== undefined) {
          formData.set("work_order[tasks][" + i + "][id]", val.id);
        }
        i++;
      }
    });

    if (transition !== "") {
      formData.set("transition", transition);
    }
    formData.set("_method", "PATCH");
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.work_order().transition(work_order.id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        dialog.title = "Orden de trabajo";
        dialog.open = true;
        dialog.success = 1;
        dialog.message = "Se ha actualizado con éxito!";
        self.setState({ dialog: dialog, saving: false });
        self.handleCloseBackdrop();
      })
      .catch(function(error) {
        dialog.title = "Orden de trabajo";
        dialog.open = true;
        dialog.success = 0;
        dialog.message = "Ha ocurrido un error!";
        var promise = new Promise(function(resolve, reject) {
          resolve(error.response.data);
          dialog.errors = error.response.data;
        });
        self.setState({ dialog: dialog, saving: false });
        self.handleCloseBackdrop();
      });

    return;
  };

  handleSubmit(e) {
    this.setState({ backdrop: true, saving: true });
    e.preventDefault();
    var i = 0;
    var dialog = this.state.dialog;
    var work_order = this.state.work_order;
    var detail = this.state.detail;
    var vehicle = this.state.vehicle;
    var formData = new FormData();
    formData.set(
      "work_order[reason]",
      work_order.reason ? work_order.reason : ""
    );
    formData.set(
      "work_order[internal_code_type]",
      work_order.internal_code_type ? work_order.internal_code_type : ""
    );
    formData.set(
      "work_order[internal_code]",
      work_order.internal_code ? work_order.internal_code : ""
    );
    formData.set(
      "work_order[freshdesk_code]",
      work_order.freshdesk_code ? work_order.freshdesk_code : ""
    );
    formData.set(
      "work_order[name]",
      work_order.reason ? work_order.reason : ""
    );
    formData.set(
      "work_order[work_order_type_id]",
      work_order.work_order_type_id
    );
    formData.set(
      "work_order[work_order_origin_id]",
      work_order.work_order_origin_id
    );
    formData.set(
      "work_order[work_order_expense_type_id]",
      work_order.work_order_expense_type_id
        ? work_order.work_order_expense_type_id
        : ""
    );
    formData.set(
      "work_order[contract_id]",
      vehicle.contract ? vehicle.contract.id : ""
    );
    formData.set("work_order[plate]", vehicle.plate);
    formData.set("work_order[km]", vehicle.km);
    formData.set("work_order[km_confirmed]", vehicle.km_confirmed ? 1 : 0);
    formData.set("work_order[is_estimated]", vehicle.is_estimated ? 1 : 0);
    if (vehicle.driver_new) {
      formData.set("work_order[driver_new]", 1);
      formData.set("work_order[driver_id]", "");
      formData.set(
        "work_order[driver_firstname]",
        vehicle.driver_firstname ? vehicle.driver_firstname : ""
      );
      formData.set(
        "work_order[driver_lastname]",
        vehicle.driver_lastname ? vehicle.driver_lastname : ""
      );
      formData.set(
        "work_order[driver_email]",
        vehicle.driver_email ? vehicle.driver_email : ""
      );
      formData.set(
        "work_order[driver_phone]",
        vehicle.driver_phone ? vehicle.driver_phone : ""
      );
    } else {
      formData.set("work_order[driver_new]", 0);
      formData.set(
        "work_order[driver_id]",
        vehicle.subcontacts[0] ? vehicle.subcontacts[0].subcontact.id : ""
      );
    }
    formData.set(
      "work_order[contact_name]",
      vehicle.contact_name ? vehicle.contact_name : ""
    );
    formData.set(
      "work_order[contact_email]",
      vehicle.contact_email ? vehicle.contact_email : ""
    );
    formData.set(
      "work_order[contact_phone]",
      vehicle.contact_phone ? vehicle.contact_phone : ""
    );
    if (vehicle.contact_new) {
      formData.set("work_order[contact_new]", 1);
      formData.set("work_order[contact_id]", "");
      formData.set(
        "work_order[contact_firstname]",
        vehicle.contact_firstname ? vehicle.contact_firstname : ""
      );
      formData.set(
        "work_order[contact_lastname]",
        vehicle.contact_lastname ? vehicle.contact_lastname : ""
      );
      formData.set(
        "work_order[contact_email]",
        vehicle.contact_email ? vehicle.contact_email : ""
      );
      formData.set(
        "work_order[contact_phone]",
        vehicle.contact_phone ? vehicle.contact_phone : ""
      );
    } else {
      formData.set("work_order[contact_new]", 0);
      formData.set("work_order[contact_id]", vehicle.contact_id);
    }
    formData.set(
      "work_order[location_lat]",
      vehicle.location.lat ? vehicle.location.lat : ""
    );
    formData.set(
      "work_order[location_lng]",
      vehicle.location.lng ? vehicle.location.lng : ""
    );
    formData.set(
      "work_order[location_province]",
      vehicle.location.province ? vehicle.location.province : ""
    );
    formData.set(
      "work_order[location_state]",
      vehicle.location.state ? vehicle.location.state : ""
    );
    formData.set(
      "work_order[location_address]",
      vehicle.location.address ? vehicle.location.address : ""
    );

    // Bookings
    if (vehicle.active_booking) {
      formData.set("work_order[booking_id]", vehicle.active_booking.id);
    } else {
      formData.set("work_order[booking_id]", "");
    }
    detail.tasks.tasks.map((val, idx) => {
      if (val.task.id !== "" && val.task.id !== undefined) {
        if (val.id !== "") {
          formData.set("work_order[tasks][" + i + "][id]", val.id);
        }
        formData.set("work_order[tasks][" + i + "][task_id]", val.task.id);
        formData.set(
          "work_order[tasks][" + i + "][work_order_task_action_id]",
          val.work_order_task_action_id
        );
        formData.set(
          "work_order[tasks][" + i + "][comments]",
          val.comments ? val.comments : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][workforce_s_iva_price]",
          val.workforce_s_iva_price ? val.workforce_s_iva_price : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][materials_s_iva_price]",
          val.materials_s_iva_price ? val.materials_s_iva_price : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][total_s_iva_price]",
          val.total_s_iva_price ? val.total_s_iva_price : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][rebill]",
          val.rebill ? val.rebill : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][total_discount]",
          val.total_discount ? val.total_discount : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][iva_buy_id]",
          val.iva_buy_id ? val.iva_buy_id : ""
        );
        formData.set(
          "work_order[tasks][" + i + "][iva_sell_id]",
          val.iva_sell_id ? val.iva_sell_id : ""
        );
        i++;
      }
    });
    let self = this;
    let errors = {};
    const token = localStorage.getItem("userToken");
    axios
      .post(api.work_order().post(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        dialog.title = "Orden de trabajo";
        dialog.success = 1;
        dialog.open = true;
        dialog.message = "Se ha creado con éxito!";
        var work_order_created = { id: "" };
        var promise = new Promise(function(resolve, reject) {
          resolve(response);
          work_order_created.id = response.data.work_order.id;
        });

        self.setState({
          dialog: dialog,
          work_order_created: work_order_created,
          saving: false
        });
        self.handleCloseBackdrop();
      })
      .catch(error => {
        dialog.title = "Orden de trabajo";
        dialog.message = "Ha ocurrido un error!";
        dialog.open = true;
        dialog.success = 0;
        //		  		dialog.errors = error.response.data
        var promise = new Promise(function(resolve, reject) {
          resolve(error.response.data);
          dialog.errors = error.response.data;
        });
        self.setState({ dialog: dialog, saving: false });
        self.handleCloseBackdrop();
      });

    return;
  }

  handleTabChange = async (e, newValue) => {
    e.preventDefault();
    if (newValue === 0) {
      await this.getWorkOrder(this.state.work_order.id);
    }
    this.setState({ tab: newValue });
  };

  getDropdowns = async () => {
    let self = this;
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.dropdowns().ot(), {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var res = response.data;
        var work_order_types = res.work_order_types;
        var work_order_origins = res.work_order_origins;
        var work_order_expense_types = res.work_order_expense_types;
        var task_action_types = res.work_order_task_actions_types;
        var iva_conditions = res.iva_conditions;
        var work_order_relation_types = res.work_order_relation_types;
        var work_order_internal_code_types = res.work_order_internal_code_types;
        this.setState({
          work_order_types: work_order_types,
          work_order_origins: work_order_origins,
          task_action_types: task_action_types,
          work_order_expense_types: work_order_expense_types,
          work_order_relation_types: work_order_relation_types,
          iva_conditions: iva_conditions,
          work_order_internal_code_types: work_order_internal_code_types
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  getNewWorkOrder = () => {
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .get(api.work_order().new(), {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var res = response.data;
        var work_order_types = res.work_order_types;
        var work_order_origins = res.work_order_origins;
        var work_order = {};
        var iva_conditions = res.iva_conditions;
        work_order.schedule = {
          provider: { business_name: "", phone: "", email: "" },
          shift_date: ""
        };
        work_order.id = "";
        var loaded = true;
        this.setState({
          work_order_types,
          work_order_origins,
          work_order,
          loaded
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiInput: {
          underline: {
            "&:before": {
              borderBottom: "0px"
            }
          }
        },
        MuiTypography: {
          caption: {
            fontWeight: 600
          }
        },
        MuiInputBase: {
          input: {
            borderBottom: "1px solid rgba(0, 0, 0, 0.42)"
          }
        }
      }
    });

  getWorkOrder = id => {
    //		this.setState({loaded: false})
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .get(api.work_order().get(id), {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var res = response.data;
        var state = this.state;
        var work_order = {};
        var schedule = {
          provider: { business_name: "", phone: "", email: "" },
          shift_date: "",
          custom_address_confirmed: false,
          shift_additional_notes_confirmed: false
        };
        var vehicle = {};
        var sinister = {};
        var relations = [];
        work_order.state = res.state;
        work_order.hansa_code = res.hansa_code;
        work_order.id = res.id;
        work_order.reason = res.reason;
        work_order.internal_code = res.internal_code;
        work_order.freshdesk_code = res.freshdesk_code;
        work_order.freshdesk_code_validated = res.freshdesk_code_validated;
        work_order.internal_code_type = res.internal_code_type;
        work_order.client_purchase_order = res.client_purchase_order;
        work_order.client_purchase_order_status =
          res.client_purchase_order_status;
        work_order.work_order_expense_type_id = res.work_order_expense_type_id;
        work_order.work_order_origin_id = res.work_order_origin_id;
        work_order.work_order_type_id = res.work_order_type_id;
        work_order.contract_id = res.contract_id;
        work_order.client_id = res.client_id;
        work_order.budgets = res.budgets;
        work_order.is_approved = res.is_approved;
        work_order.official_provider_required = res.official_provider_required
          ? res.official_provider_required
          : false;
        work_order.default_provider_type_id = res.type.default_provider_type_id
          ? res.type.default_provider_type_id
          : "";
        work_order.default_voucher_type_id = res.type.default_voucher_type_id
          ? res.type.default_voucher_type_id
          : "";
        work_order.can_change_payment_deadline = res.type
          .payment_deadline_change
          ? res.type.payment_deadline_change
          : false;
        work_order.materials_price_enable = res.materials_price_enable;
        work_order.work_force_price_enable = res.work_force_price_enable;
        work_order.total_price_enable = res.total_price_enable;
        work_order.is_fleet_owner = res.vehicle.is_fleet_owner;
        work_order.oc_sap_code = res.oc_sap_code ? res.oc_sap_code : "";
        work_order.reception_sap_code = res.reception_sap_code
          ? res.reception_sap_code
          : "";
        work_order.restore = res.restore ? res.restore : false;
        work_order.show_budget_required_label = res.show_budget_required_label
          ? res.show_budget_required_label
          : false;
        work_order.allow_tasks_added =
          parseInt(res.type.allow_tasks_added) === 1 ? true : false;
        work_order.insurance_franchise = res.insurance_franchise
          ? res.insurance_franchise
          : "";
        work_order.sap_dimensions = res.sap_dimensions
          ? res.sap_dimensions
          : {};
        schedule = res.schedule;
        schedule.shift_date = schedule.shift_date.replace(" ", "T");
        schedule.q_shift_sent = parseInt(schedule.q_shift_sent);
        sinister = res.sinister;
        vehicle.id = res.vehicle.id;
        vehicle.plate = res.vehicle.plate;
        vehicle.owner = res.vehicle.owner;
        vehicle.description = res.vehicle.description;
        vehicle.is_fleet_owner = res.vehicle.is_fleet_owner;
        vehicle.is_estimated = res.is_estimated;
        vehicle.km = res.km;
        vehicle.km_confirmed = true;
        vehicle.last_km = res.vehicle.last_km;
        vehicle.last_km_origin = res.vehicle.last_km_origin;
        vehicle.last_km_date = res.vehicle.last_km_date;
        vehicle.client = {};
        vehicle.client.business_name = res.contract ? res.contract : "";
        vehicle.contacts = [res.contacts];
        vehicle.contact_name = res.contact_name;
        vehicle.contact_new = false;
        vehicle.contact_phone = res.contact_phone;
        vehicle.contact_email = res.contact_email;
        vehicle.contact_id = res.contact_id;
        vehicle.version = res.vehicle.version_full_name;
        vehicle.location = {
          lat: res.location.lat,
          lng: res.location.lng,
          address: res.location.address,
          province: res.location.province,
          state: res.location.state
        };

        if (res.booking) {
          vehicle.client.business_name = res.booking.client;
          vehicle.active_booking = res.booking;
        }
        vehicle.work_orders = [{ id: 0 }];
        if (res.driver) {
          vehicle.subcontacts = [
            {
              subcontact: {
                id: res.driver.id,
                firstname: res.driver.firstname,
                lastname: res.driver.lastname,
                contact: {
                  phone: res.driver.contact.phone,
                  email: res.driver.contact.email,
                  id: res.driver.contact.id
                }
              }
            }
          ];
        } else {
          vehicle.subcontacts = [
            {
              subcontact: {
                firstname: "",
                lastname: "",
                contact: { phone: "", email: "" }
              }
            }
          ];
        }
        res.work_order_relation_to.map((val, idx) => {
          relations.push(val);
        });
        res.work_order_relation_from.map((val, idx) => {
          relations.push(val);
        });
        work_order.totals = {
          total_s_iva_price: res.total_s_iva_price,
          materials_s_iva_price: res.materials_s_iva_price,
          workforce_s_iva_price: res.workforce_s_iva_price
        };
        work_order.booking = res.booking;
        work_order.mobile_data = res.mobile_data;
        var next_state = res.next_state;
        var can_cancel = res.can_cancel;
        var loaded = true;
        var detail = {};
        var type = this.state.work_order_types.filter(
          type => type.id === work_order.work_order_type_id
        );

        detail.tasks = {};
        detail.tasks.tasks = res.tasks;
        if (can_cancel)
          detail.tasks.tasks.push({ task: { name: "", action: { id: "" } } });

        this.setState({
          work_order,
          next_state,
          loaded,
          vehicle,
          detail,
          schedule,
          relations,
          sinister,
          can_cancel,
          components: type[0].components
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleDialogClose = () => {
    var dialog = this.state.dialog;
    dialog.open = false;
    dialog.errors = [];
    var delete_dialog = this.state.delete_dialog;
    delete_dialog.open = false;
    delete_dialog.errors = [];

    this.setState({ dialog: dialog, delete_dialog: delete_dialog });
  };

  handleDialogAccept = () => {
    if (
      this.state.dialog.success === 1 ||
      this.state.delete_dialog.success === 1
    ) {
      if (this.state.work_order.id !== "" || this.state.work_order_created) {
        var id = this.state.work_order.id
          ? this.state.work_order.id
          : this.state.work_order_created.id;
        window.location.href = "/work-order/" + id;
      } else {
        window.location.href = `/work-orders`;
      }
    } else {
      this.handleDialogClose();
    }
  };

  handleDialogCancel = () => {
    if (this.state.dialog.errors) {
      window.location.href = `/work-orders`;
    } else {
      this.handleDialogClose();
    }
  };

  handleCancelButton = () => {
    window.location.href = `/work-orders`;
  };

  handleDeleteButton = () => {
    var delete_dialog = this.state.delete_dialog;
    delete_dialog.open = true;
    delete_dialog.title = "Orden de trabajo";
    delete_dialog.message =
      "Esta seguro de cancelar esta Orden de trabajo? La misma se cerrará automaticamente.";
    this.setState({ delete_dialog: delete_dialog });
  };

  handleCloseWorkOrder = () => {
    var dialog = this.state.dialog;
    dialog.title = "Orden de trabajo";
    const token = localStorage.getItem("userToken");
    var id = this.state.work_order.id;
    axios
      .delete(api.work_order().delete(id), {
        headers: { Authorization: `Bearer ${token}` },
        params: { id: id }
      })

      .then(res => {
        dialog.open = true;
        dialog.success = 1;
        dialog.message = "Se canceló la OT con éxito!";
        this.setState({ dialog: dialog });
      })
      .catch(err => {
        dialog.open = true;
        dialog.success = 0;
        dialog.message =
          "Ha ocurrido un error al cancelar la OT. Por favor contacte a su administrador";
        var errors = {};
        var promise = new Promise(function(resolve, reject) {
          resolve(err.response.data);
          errors = err.response.data;
        });
        errors = errors.errors;
        if (errors) {
          if (errors.id) dialog.message = errors.id[0];
        }
        this.setState({ dialog: dialog });
      });
  };

  handleScheduleChange = (name, value) => {
    var schedule = this.state.schedule;
    if (name === "custom_address_confirmed") {
      value = value === "true" ? true : false;
    }
    schedule[name] = value;
    //    	schedule.shift_date = shift_date
    this.setState({ schedule: schedule });
  };

  handleLocationChange = location => {
    var vehicle = this.state.vehicle;
    vehicle.location = location;
    this.setState({ vehicle: vehicle });
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  handlePlateChange = () => {
    var vehicle = this.state.vehicle;
    var work_order = this.state.work_order;
    work_order.is_fleet_owner = vehicle.is_fleet_owner;
    var work_order_type = this.state.work_order_types.filter(
      type => parseInt(type.id) === this.state.work_order.work_order_type_id
    );
    work_order.work_order_expense_type_id = "";
    if (work_order_type[0]) {
      var expense_type = work_order_type[0].expenses.filter(
        expense =>
          parseInt(expense.default) === 1 &&
          parseInt(expense.fleet_owner) === parseInt(vehicle.is_fleet_owner)
      );
      if (expense_type[0]) {
        work_order.work_order_expense_type_id = expense_type[0].expense.id;
      }
    }
    this.setState({ work_order: work_order });
  };

  handleWorkOrderTypeChanged = () => {
    var work_order = this.state.work_order;
    const type = this.state.work_order_types.filter(
      type => type.id === parseInt(this.state.work_order.work_order_type_id)
    );
    const default_work_order_task_action_id =
      type[0].default_work_order_task_action_id;
    const work_force_price_enable = type[0].work_force_price_enable;
    const materials_price_enable = type[0].materials_price_enable;
    work_order.default_work_order_task_action_id =
      default_work_order_task_action_id || false;
    work_order.work_force_price_enable =
      parseInt(work_force_price_enable) === 1 ? true : false;
    work_order.materials_price_enable =
      parseInt(materials_price_enable) === 1 ? true : false;
    this.setState({ work_order: work_order });
  };

  handleUpdateWorkOrderState = () => {
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .get(api.work_order().getState(this.state.work_order.id), {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var res = response.data;
        var work_order = this.state.work_order;
        var next_state = this.state.next_state;
        work_order.state = res.state;
        next_state = res.next_state;
        this.setState({ work_order, next_state });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  render() {
    return (
      <MuiThemeProvider theme={this.getMuiTheme()}>
        <React.Fragment>
          <Container
            fluid
            className="main-content-container px-4 position-relative"
          >
            {this.state.loaded ? (
              <React.Fragment>
                <ConfirmDialog
                  confirm_dialog={this.state.delete_dialog.open}
                  title={this.state.delete_dialog.title}
                  message={this.state.delete_dialog.message}
                  onClose={this.handleDialogClose}
                  onAccept={this.handleCloseWorkOrder}
                  onCancel={this.handleDialogCancel}
                  errors={this.state.dialog.errors}
                />
                <ConfirmDialog
                  confirm_dialog={this.state.dialog.open}
                  title={this.state.dialog.title}
                  message={this.state.dialog.message}
                  onClose={this.handleDialogClose}
                  onAccept={this.handleDialogAccept}
                  onCancel={this.handleDialogCancel}
                  errors={this.state.dialog.errors}
                />
                <Row noGutters className="page-header">
                  <Typography variant="h6">
                    Orden de Trabajo #{this.state.work_order.id} (
                    {this.state.work_order.hansa_code}) - Estado:{" "}
                    {this.state.work_order.state}
                  </Typography>
                </Row>
                <Row className="ml-1 mt-1">
                  <BasicDataComponent
                    work_order_origins={this.state.work_order_origins}
                    work_order_types={this.state.work_order_types}
                    work_order={this.state.work_order}
                    work_order_expense_types={
                      this.state.work_order_expense_types
                    }
                    is_fleet_owner={this.state.vehicle.is_fleet_owner}
                    work_order_internal_code_types={
                      this.state.work_order_internal_code_types
                    }
                    onTypeChanged={this.handleWorkOrderTypeChanged}
                    vehicle={this.state.vehicle}
                    forceSave={e => this.handleTransition(e, "")}
                  />
                </Row>
                <Row className="ml-1">
                  <VehicleComponent
                    vehicle={this.state.vehicle}
                    work_order_id={this.state.work_order.id}
                    onLocationChange={this.handleLocationChange}
                    onPlateChanged={this.handlePlateChange}
                  />
                </Row>
                <Row className="ml-1">
                  <ScheduleComponent
                    schedule={this.state.schedule}
                    onScheduleChange={this.handleScheduleChange}
                    work_order_id={this.state.work_order.id}
                  />
                </Row>

                {/*							{(this.state.schedule.provider.business_name)
								?
									<React.Fragment>
										<Row className="ml-1">
											<ScheduleComponent schedule={this.state.schedule}/>
										</Row>
									</React.Fragment>
								:
								''
							}
*/}
                <React.Fragment>
                  <AppBar position="static" color="default">
                    <Tabs
                      value={this.state.tab}
                      onChange={this.handleTabChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="scrollable"
                      scrollButtons="auto"
                      aria-label="scrollable auto tabs example"
                      style={{ minHeight: "20px" }}
                    >
                      {this.state.work_order.work_order_type_id > 0 &&
                      this.state.components.length > 0 ? (
                        this.state.components.map((val, idx) => {
                          return (
                            <Tab
                              label={val.component}
                              {...a11yProps(val.order)}
                              style={{ minHeight: "20px" }}
                            />
                          );
                        })
                      ) : this.state.work_order.initial_detail === 1 ? (
                        <Tab
                          label={"Detalle"}
                          {...a11yProps(0)}
                          style={{ minHeight: "20px" }}
                        />
                      ) : (
                        ""
                      )}
                      {/*	
										<Tab label="Detalle" {...a11yProps(0)} style={{minHeight: '20px'}} />
										<Tab label="Presupuesto" {...a11yProps(1)} style={{minHeight: '20px'}}  />
										<Tab label="Proveedores" {...a11yProps(2)} style={{minHeight: '20px'}}  />
										<Tab label="Comprobantes" {...a11yProps(3)} style={{minHeight: '20px'}}  />
										<Tab label="Relaciones" {...a11yProps(4)} style={{minHeight: '20px'}}  />
										<Tab label="Historia" {...a11yProps(5)} style={{minHeight: '20px'}}  />
										<Tab label="Archivos adjuntos" {...a11yProps(6)} style={{minHeight: '20px'}}  />
										<Tab label="Mensajes" {...a11yProps(7)} style={{minHeight: '20px'}}  />
										<Tab label="Siniestros" {...a11yProps(8)} style={{minHeight: '20px'}} className={(this.state.work_order.id !== '' && this.state.work_order.work_order_type_id === 2 ) ? '' : 'd-none' } />
										<Tab label="Movimiento Interno" {...a11yProps(9)} style={{minHeight: '20px'}}  className={(this.state.work_order.id !== '' && this.state.work_order.work_order_type_id === 5 ) ? '' : 'd-none' } /> 
										<Tab label="Valet" {...a11yProps(10)} style={{minHeight: '20px'}}   className={(this.state.work_order.id !== '' && this.state.work_order.work_order_type_id === 6 ) ? '' : 'd-none' } /> 
									*/}
                    </Tabs>
                  </AppBar>
                  {this.state.work_order.work_order_type_id > 0 &&
                  this.state.components.length > 0 ? (
                    this.state.components.map((val, idx) => {
                      return (
                        <React.Fragment>
                          <TabPanel value={this.state.tab} index={val.order}>
                            {val.component === "Detalle" ? (
                              <DetailComponent
                                detail={this.state.detail}
                                task_action_types={this.state.task_action_types}
                                work_order_expense_type_id={
                                  this.state.work_order
                                    .work_order_expense_type_id
                                }
                                iva_conditions={this.state.iva_conditions}
                                can_delete={this.state.can_cancel}
                                is_approved={this.state.work_order.is_approved}
                                work_order_id={this.state.work_order.id}
                                totals={this.state.work_order.totals}
                                default_work_order_task_action_id={
                                  this.state.work_order
                                    .default_work_order_task_action_id
                                }
                                work_force_price_enable={
                                  this.state.work_order.work_force_price_enable
                                }
                                materials_price_enable={
                                  this.state.work_order.materials_price_enable
                                }
                                total_price_enable={
                                  this.state.work_order.total_price_enable
                                }
                                work_order_type_id={
                                  this.state.work_order.work_order_type_id
                                }
                                show_budget_required_label={
                                  this.state.work_order
                                    .show_budget_required_label
                                }
                                filterTasks={
                                  !this.state.work_order.allow_tasks_added
                                }
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Mobile" ? (
                              this.state.work_order.mobile_data ? (
                                <Mobile
                                  mobile_data={
                                    this.state.work_order.mobile_data
                                  }
                                />
                              ) : (
                                "No se cargó por la app mobile"
                              )
                            ) : (
                              ""
                            )}
                            {val.component === "SAP" ? (
                              <SAP
                                work_order={this.state.work_order}
                                onUpdateWorkOrderState={() => {
                                  this.handleUpdateWorkOrderState();
                                  this.getWorkOrder(this.state.work_order.id);
                                }}
                              />
                            ) : (
                              ""
                            )}

                            {val.component === "Presupuesto" ? (
                              <BudgetComponent
                                work_order={this.state.work_order}
                                tasks={this.state.detail}
                                plate={this.state.vehicle.plate}
                                onUpdateWorkOrderState={
                                  this.handleUpdateWorkOrderState
                                }
                                can_cancel={this.state.can_cancel}
                              />
                            ) : (
                              ""
                            )}

                            {val.component === "Proveedores" ? (
                              <ProviderComponent
                                work_order={this.state.work_order}
                                contact_location={this.state.vehicle.location}
                                plate={this.state.vehicle.plate}
                                onUpdateWorkOrderState={
                                  this.handleUpdateWorkOrderState
                                }
                                mobile_data={this.state.work_order.mobile_data}
                              />
                            ) : (
                              ""
                            )}

                            {val.component === "Relaciones" ? (
                              <RelationComponent
                                id={this.state.work_order.id}
                                relations={this.state.relations}
                                work_order_relation_types={
                                  this.state.work_order_relation_types
                                }
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Cochera" ? (
                              <ParkingComponent id={this.state.work_order.id} />
                            ) : (
                              ""
                            )}
                            {val.component === "Aprobacion" ? (
                              <ApprovalComponent
                                id={this.state.work_order.id}
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Cubiertas" ? (
                              <TiersComponent
                                work_order_id={this.state.work_order.id}
                                disabled={!this.state.can_cancel ? true : false}
                              />
                            ) : (
                              ""
                            )}

                            {val.component === "FAC/ND" ? (
                              <>
                                <VouchersComponent
                                  work_order={this.state.work_order}
                                  tasks={this.state.detail}
                                  can_edit={
                                    this.state.work_order.state !== "cerrada"
                                      ? true
                                      : false
                                  }
                                  iva_conditions={this.state.iva_conditions}
                                  onUpdateWorkOrderState={
                                    this.handleUpdateWorkOrderState
                                  }
                                  default_voucher_type_id={
                                    this.state.work_order.default_voucher_type_id
                                  }
                                  can_change_payment_deadline={
                                    this.state.work_order
                                      .can_change_payment_deadline
                                  }
                                  disabled={
                                    this.state.work_order.state === "cerrada" ||
                                    this.state.work_order.state === "cancelada"
                                  }
                                />
                                <WorkOrderInvoices work_order_id={this.state.work_order.id} />
                              </>
                            ) : (
                              ""
                            )}

                            {val.component === "Historia" ? (
                              <HistoryComponent id={this.state.work_order.id} />
                            ) : (
                              ""
                            )}

                            {val.component === "Archivos adjuntos" ? (
                              <AttachmentsComponent
                                id={this.state.work_order.id}
                              />
                            ) : (
                              ""
                            )}

                            {val.component === "Siniestros" ? (
                              <SinisterComponent
                                work_order_id={this.state.work_order.id}
                                plate={this.state.vehicle.plate}
                                onUpdateWorkOrderState={
                                  this.handleUpdateWorkOrderState
                                }
                                booking={this.state.work_order.booking}
                                insurance_franchise={
                                  this.state.work_order.insurance_franchise
                                }
                              />
                            ) : (
                              ""
                            )}

                            {val.component === "Valet" ? (
                              <ValetComponent
                                id={this.state.work_order.id}
                                client_id={this.state.work_order.client_id}
                                onUpdateWorkOrderState={
                                  this.handleUpdateWorkOrderState
                                }
                              />
                            ) : (
                              ""
                            )}

                            {val.component === "Movimiento interno" ? (
                              <VehicleMovementComponent
                                id={this.state.work_order.id}
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Abogados" ? (
                              <SinisterLawyerDiligenceComponent
                                work_order_id={this.state.work_order.id}
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Mensajes" ? (
                              <MobileMessages
                                endpoint={api
                                  .mobile_messages()
                                  .ot(this.state.work_order.id)}
                                model="work_order"
                                model_key="id"
                                id={this.state.work_order.id}
                                title="Mensajes de OT"
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Subtareas" ? (
                              <UserAlertsComponent
                                work_order_id={this.state.work_order.id}
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Comentarios" ? (
                              <CommentsComponent
                                work_order_id={this.state.work_order.id}
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Checklist" ? (
                              <WorkOrderChecklist
                                work_order_id={this.state.work_order.id}
                              />
                            ) : (
                              ""
                            )}
                            {val.component === "Infracciones" ? (
                              <Fine id={this.state.work_order.id} />
                            ) : (
                              ""
                            )}
                          </TabPanel>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <React.Fragment>
                      {this.state.work_order.initial_detail === 1 ? (
                        <TabPanel value={this.state.tab} index={0}>
                          <DetailComponent
                            detail={this.state.detail}
                            task_action_types={this.state.task_action_types}
                            work_order_expense_type_id={
                              this.state.work_order.work_order_expense_type_id
                            }
                            iva_conditions={this.state.iva_conditions}
                            default_work_order_task_action_id={
                              this.state.work_order
                                .default_work_order_task_action_id
                            }
                            work_force_price_enable={
                              this.state.work_order.work_force_price_enable
                            }
                            materials_price_enable={
                              this.state.work_order.materials_price_enable
                            }
                          />
                        </TabPanel>
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  )}
                  {/*
								<TabPanel value={this.state.tab} index={0}>
									<DetailComponent detail={this.state.detail} task_action_types={this.state.task_action_types} work_order_expense_type_id={this.state.work_order.work_order_expense_type_id}/>
								</TabPanel>
								<TabPanel value={this.state.tab} index={1}>
										<BudgetComponent work_order={this.state.work_order} tasks={this.state.detail} />
								</TabPanel>
								<TabPanel value={this.state.tab} index={2}>
									<ProviderComponent work_order={this.state.work_order} contact_location={this.state.vehicle.location} />
								</TabPanel>
								<TabPanel value={this.state.tab} index={3} >
									<VouchersComponent work_order={this.state.work_order}/>
								</TabPanel>
								<TabPanel value={this.state.tab} index={4}>
									<RelationComponent id={this.state.work_order.id} relations={this.state.relations} work_order_relation_types={this.state.work_order_relation_types}/>
								</TabPanel>
								<TabPanel value={this.state.tab} index={5}>
									<HistoryComponent id={this.state.work_order.id} />
								</TabPanel>
								<TabPanel value={this.state.tab} index={6}>
									<AttachmentsComponent id={this.state.work_order.id} />
								</TabPanel>
								<TabPanel value={this.state.tab} index={7}>
								</TabPanel>
								<TabPanel value={this.state.tab} index={8}>
									<SinisterComponent work_order_id={this.state.work_order.id} plate={this.state.vehicle.plate}/>
								</TabPanel>
								<TabPanel value={this.state.tab} index={9}>
									<VehicleMovementComponent id={this.state.work_order.id}/>
								</TabPanel>
								<TabPanel value={this.state.tab} index={10}>
									<ValetComponent id={this.state.work_order.id}/>
								</TabPanel>
*/}
                </React.Fragment>
                <div
                  className="position-absolute"
                  style={{ right: 0, bottom: 0 }}
                >
                  <ButtonGroup
                    size="small"
                    variant="contained"
                    className="mt-3"
                  >
                    {this.state.work_order.id === "" ? (
                      <Button
                        disabled={this.state.saving}
                        variant="contained"
                        color="primary"
                        onClick={e => {
                          this.handleSubmit(e);
                        }}
                      >
                        Guardar
                      </Button>
                    ) : (
                      this.state.tab === 0 &&
                      this.state.next_state.map((val, idx) => {
                        return val.transition.map((val2, idx2) => {
                          return (
                            <Button
                              disabled={this.state.saving}
                              className="mr-1"
                              variant="contained"
                              color="primary"
                              style={{ backgroundColor: "green" }}
                              onClick={e => {
                                this.handleTransition(e, val.state);
                              }}
                            >
                              {val2}
                            </Button>
                          );
                        });
                      })
                    )}
                    {this.state.tab === 0 &&
                    this.state.work_order.id !== "" &&
                    this.state.work_order.state !== "cerrada" &&
                    this.state.work_order.state !== "cancelada" ? (
                      <Button
                        disabled={this.state.saving}
                        className="mr-1"
                        variant="contained"
                        color="primary"
                        onClick={e => {
                          this.handleTransition(e, "");
                        }}
                      >
                        Guardar
                      </Button>
                    ) : (
                      ""
                    )}
                    {this.state.work_order.restore === true ? (
                      <Button
                        className="mr-1"
                        variant="contained"
                        color="primary"
                        onClick={e => {
                          this.handleRestore(e, "");
                        }}
                      >
                        Reabrir
                      </Button>
                    ) : (
                      ""
                    )}
                    <Button
                      className="mr-1"
                      variant="contained"
                      color="secondary"
                      onClick={e => {
                        this.handleCancelButton();
                      }}
                    >
                      Volver
                    </Button>
                    {this.state.can_cancel ? (
                      <Button
                        className="mr-1"
                        variant="contained"
                        color="secondary"
                        onClick={e => {
                          this.handleDeleteButton();
                        }}
                      >
                        Cancelar OT
                      </Button>
                    ) : (
                      ""
                    )}
                  </ButtonGroup>
                </div>
              </React.Fragment>
            ) : (
              <LinearProgress />
            )}
          </Container>
        </React.Fragment>
        <React.Fragment>
          <Backdrop
            open={this.state.backdrop}
            onClick={this.handleCloseBackdrop}
            style={{ zIndex: 10000, color: "#3f51b5" }}
          >
            <Typography className="ml-2" variant="h5" color="primary">
              Guardando...
            </Typography>
          </Backdrop>
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}
export default WorkOrder;
